var map = {
	"./24.svg": 1339,
	"./CDN-Header.svg": 923,
	"./CloudGuard-Service.svg": 1340,
	"./DNS.svg": 1341,
	"./HA.svg": 1342,
	"./Isolation.svg": 1343,
	"./ManagedService-Service.svg": 1344,
	"./VPC-Main.svg": 1283,
	"./VPC-Service.svg": 1345,
	"./architect.svg": 1346,
	"./backup.svg": 1347,
	"./blancing.svg": 1348,
	"./chooseOs.svg": 1349,
	"./container.svg": 1350,
	"./dashboard.svg": 1351,
	"./ddos-image.svg": 1284,
	"./devops.svg": 1352,
	"./freeSupport.svg": 1353,
	"./global.svg": 1354,
	"./header.svg": 1355,
	"./improve.svg": 1356,
	"./increase.svg": 1357,
	"./kuber.svg": 1358,
	"./migration.svg": 1359,
	"./monitoring.svg": 1360,
	"./openstack.svg": 1361,
	"./panel.svg": 1362,
	"./plans.svg": 1363,
	"./resource.svg": 1364,
	"./service.svg": 1365,
	"./sla.svg": 1366,
	"./snapshot.svg": 1367,
	"./support.svg": 1368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1159;